import { Summary } from '../summary';
import { AdjustmentEffectiveness } from '../adjustment-effectiveness';

export class AdjustmentEffectivenessModalPayload {
  summary: Summary;
  adjustmentEffectiveness: AdjustmentEffectiveness[];
}
